//export const pathsForPageLoadAds = ['/articleshow/', '/'];
const exactPathsForPageLoadAds = {
  web: ['/', '/us'],
  wap: ['/', '/us'],
};
const partialPathsForPageLoadAds = {
  web: ['/articleshow/', '/liveblog/', '/topic/', '/videoshow/'],
  wap: ['/articleshow/', '/liveblog/', '/topic/', '/videoshow/'],
};
export const isAdsNativeImplementation = (path, isMobile = true) => {
  const key = isMobile ? 'wap' : 'web';
  let isNativeImpl = false;
  const partialPathsForPageLoadAdsArr = partialPathsForPageLoadAds[key];
  isNativeImpl = partialPathsForPageLoadAdsArr.some(partialPath =>
    path.includes(partialPath),
  );
  if (!isNativeImpl) {
    const exactPathsForPageLoadAdsArr = exactPathsForPageLoadAds[key];
    isNativeImpl = exactPathsForPageLoadAdsArr.some(
      exactPath => path === exactPath,
    );
  }
  return isNativeImpl;
};
export const InnovFallback = [
  {
    adCode: '/7176/TOI/TOI_ROS/TOI_ROS_Sticky_LHS_125',
    size: [[125, 600], [160, 600], [120, 600]],
    divId: 'TOI_appgutter_left',
    perpetualRefresh: 1,
  },
  {
    adCode: '/7176/TOI/TOI_ROS/TOI_ROS_Sticky_RHS_125',
    size: [[125, 600], [160, 600], [120, 600]],
    divId: 'TOI_appgutter_right',
    perpetualRefresh: 1,
  },
];
export const gptHeadAppendScript = ``;
